import { StyleSheet } from '@react-pdf/renderer';

interface StyleMap {
  [key: string]: any;
}

const conditionStyles = {
  defaultFace: { fill: '#FFFFFF', stroke: '#333', strokeWidth: 0.5 },
  marcadoVermelho: { fill: '#FF0000', stroke: '#333', strokeWidth: 0.5 }, // Amálgama
  marcadoAmarelo: { fill: '#FFD700', stroke: '#333', strokeWidth: 0.5 }, // Cáries
  marcadoMarrom: { fill: '#8B4513', stroke: '#333', strokeWidth: 0.5 }, // Resina
  marcadoVerde: { fill: '#008000', stroke: '#333', strokeWidth: 0.5 }, // Selante
  marcadoLaranja: { fill: 'none', stroke: '#FFA500', strokeWidth: 4.0 }, // Endodontia
  marcadoTomate: { fill: 'none', stroke: '#FF6347', strokeWidth: 1.5 }, // Ausente
  marcadoRoxo: { fill: '#cc66cc', stroke: '#333', strokeWidth: 0.5 }, // Implante
  marcadoAzul: { fill: 'none', stroke: '#0000FF', strokeWidth: 4.0 }, // Coroa
  marcadoVerdeClaro: { fill: 'none', stroke: '#90EE90', strokeWidth: 4.5 }, // Outros
  none: { fill: '#fff', stroke: '#333', strokeWidth: 2 },
};

export const OdontogramPdfStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: 10,
  },
  arcadaContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 8,
    padding: 6,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#BDC3C7',
  },
  arcadaLabel: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#2C3E50',
    marginBottom: 10,
    textTransform: 'uppercase',
  },
  arcadaRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
  },
  toothNumber: {
    fontSize: 12,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    fill: '#2C3E50',
  },
  ...conditionStyles,
} as StyleMap);
